


















// Mixins
import { inject as RegistrableInject } from '@/mixins/registrable';

import Proxyable from '@/mixins/proxyable';

import { get } from 'vuex-pathify';
import { mapActions } from 'vuex';

import { IQuoteServiceVariable, IQuoteTemplate } from '@/models';
import { ErrorManager } from '@/models/error';
import mixins, { ExtractVue } from '@/utils/mixins';
import { VNodeData } from 'vue';

const baseMixins = mixins(
  Proxyable,
  RegistrableInject<'template', any>('template')
);

interface Options extends ExtractVue<typeof baseMixins> {
  template: IQuoteTemplate;
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'QuoteServiceVariableSearch',

    data() {
      return {
        search: '' as string,
        errorMessage: '',
        serviceTemplateId: null as number | null
      };
    },

    computed: {
      quoteServiceVariables: get<IQuoteServiceVariable[]>(
        'quoteServiceVariable/getQuoteServiceVariables'
      ),

      getQuoteServiceVariablesByService: get<
        (service: null | number) => IQuoteServiceVariable[]
      >('quoteServiceVariable/getQuoteServiceVariablesByService'),

      serviceVariables(): (
        | IQuoteServiceVariable
        | { divider: boolean }
        | { header: string }
      )[] {
        const serviceFilteredVariables: (
          | IQuoteServiceVariable
          | ({ divider: boolean } & VNodeData)
          | ({ header: string } & VNodeData)
        )[] = this.getQuoteServiceVariablesByService(this.serviceTemplateId);
        const serviceUnfilteredVariables = this.quoteServiceVariables.filter(
          variable => !variable.service
        );

        if (serviceFilteredVariables.length) {
          serviceFilteredVariables.push({ divider: true });
          serviceFilteredVariables.push({
            header: 'Global Variables'
          });
        }
        return serviceFilteredVariables.concat(serviceUnfilteredVariables);
      }
    },

    methods: {
      ...mapActions({
        fetchQuoteServiceVariables:
          'quoteServiceVariable/fetchQuoteServiceVariables'
      }),

      clearInternalErrors() {
        this.errorMessage = '';
      },

      clearAllErrors() {
        this.clearInternalErrors();
        this.$emit('clearAllErrors');
      },

      clearInput() {
        this.clearInternalErrors();
        this.$emit('click:clear');
      }
    },

    created() {
      this.template.register(this);
    },

    beforeDestroy() {
      this.template.unregister(this);
    },

    mounted() {
      this.clearAllErrors();
    }
  });
